import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { CardRightArrow, CircleSpinner } from '../../../assets/svg';
import { CUSTOMER_DASHBOARD, QUERY_KEYS, ROUTES } from '../../../constants';
import { CustomDropdown, ViewAll } from '../../shared';
import { getHiringClients, handleScroll, popup } from '../../../utils';
import { useQuery } from '@tanstack/react-query';

const CustomerDashboardHiringClients = ({ platforms, isLoading }) => {
    const navigate = useNavigate();
    const scrollBar = useRef(null);
    const [isScrolling, setIsScrolling] = useState(false);
    const [selectedPlatformID, setSelectedPlatformID] = useState('');

    const customerId = useSelector((state) => state.accountArray.selectedAccount);

    const handleRedirect = (hc) => {
        navigate(ROUTES.CUSTOMER.HIRING_CLIENTS, {
            state: { id: hc.id, hiringClientName: hc.name },
        });
    };

    const handleScrolling = () => {
        handleScroll(setIsScrolling, scrollBar, 2000);
    };

    const {
        data: hiringClients,
        isError,
        error,
        isLoading: hcLoading,
    } = useQuery({
        queryKey: [QUERY_KEYS.HIRING_CLIENTS, customerId, selectedPlatformID],
        queryFn: async () =>
            await getHiringClients({
                account_id: customerId,
                platform_id: selectedPlatformID,
            }),
        select: (data) => data?.data || [],
        enabled: !!customerId && !!selectedPlatformID,
    });
    if (isError) popup('error', error.message);

    useEffect(() => {
        if (platforms && platforms.length) setSelectedPlatformID(platforms[0].id);
    }, [platforms]);

    return (
        <div className='col-12 col-xl-6 custom-col-set bottom-left mb-4 mb-xl-0'>
            <div className='h-100 card-container ssc-shadow d-flex flex-column w-100 align-items-center p-lg-4 p-3 position-relative'>
                <div className='card-title-area d-flex w-100 align-items-center justify-content-between'>
                    <h5>
                        Hiring Clients
                        <span className='text-info'>
                            {platforms && platforms.length > 0
                                ? ` (${hiringClients?.length || 0})`
                                : ''}
                        </span>
                    </h5>
                    {platforms && platforms.length > 0 && (
                        <CustomDropdown
                            options={platforms.map((platform) => ({
                                ...platform,
                                name: `${platform.name}®`,
                            }))}
                            handleOptionSelect={(option) => {
                                setSelectedPlatformID(option?.id);
                            }}
                            selectedOption={selectedPlatformID}
                            minWidth='200px'
                        />
                    )}
                </div>
                <div
                    onScroll={handleScrolling}
                    className={`content-set-area flex-column d-flex flex-fill w-100 align-items-start justify-content-start ${hiringClients?.length >= 20 ? 'pb-5': ' '} ${isScrolling ? 'scrolling' : 'not-scrolling'}`}
                >
                    {platforms?.length > 0 && hiringClients?.length > 0
                        ? hiringClients.map((hc, index) => (
                              <div
                                  key={index}
                                  className='content-set d-flex w-100 align-items-center justify-content-between cursor-pointer'
                                  type='button'
                                  onClick={() => handleRedirect(hc)}
                              >
                                  <div>
                                      <p className='mb-0'>{hc.name}</p>
                                  </div>
                                  <div className='d-flex align-items-center justify-content-end'>
                                      <CardRightArrow width={16} height={16} />
                                  </div>
                              </div>
                          ))
                        : CUSTOMER_DASHBOARD.HIRING_CLIENT_NOT_FOUND}
                </div>
                {hiringClients?.length >= 20 && (
                    <div className='view-btn d-flex justify-content-start position-absolute bottom-0 z-3 w-100 height-60px bg-white align-items-center'>
                        <ViewAll
                            className='ssc-card-btn2 ps-3'
                            navigateTo={ROUTES.CUSTOMER.HIRING_CLIENTS}
                        />
                    </div>
                )}
                {(isLoading || hcLoading) && <CircleSpinner absolute size='3rem' />}
            </div>
        </div>
    );
};

CustomerDashboardHiringClients.propTypes = { platforms: PropTypes.array };

export default CustomerDashboardHiringClients;
